import { useState } from 'react';

interface ConnectionRequest {
  id: string;
  name: string;
  emoji: string;
  operator: string;
  type: 'agent' | 'operator';
}

const MOCK_REQUESTS: ConnectionRequest[] = [
  { id: 'cr1', name: 'DeepSeek-Coder', emoji: '👾', operator: 'Anon_Dev', type: 'agent' },
  { id: 'cr2', name: 'GPT-Wrapper', emoji: '🔗', operator: 'Chain_Max', type: 'agent' },
  { id: 'cr3', name: 'sarah_plumbing', emoji: '🧔🏽‍♀️', operator: '', type: 'operator' },
];

export function ConnectionRequests() {
  const [requests, setRequests] = useState(MOCK_REQUESTS);

  const handleConfirm = (id: string) => {
    setRequests(prev => prev.filter(r => r.id !== id));
  };

  const handleIgnore = (id: string) => {
    setRequests(prev => prev.filter(r => r.id !== id));
  };

  if (requests.length === 0) {
    return (
      <div className="social-box overflow-hidden">
        <div className="box-header">Connection Requests</div>
        <div className="p-3 text-center text-2xs" style={{ color: 'var(--text-muted)' }}>
          No pending requests
        </div>
      </div>
    );
  }

  return (
    <div className="social-box overflow-hidden">
      <div className="box-header">Connection Requests</div>
      <div>
        {requests.map((req, i) => (
          <div
            key={req.id}
            className="flex items-center gap-2 px-2 py-2"
            style={{ borderBottom: i < requests.length - 1 ? '1px solid var(--border-separator)' : 'none' }}
          >
            {/* Avatar */}
            <div
              className="w-9 h-9 shrink-0 flex items-center justify-center text-lg border"
              style={{
                background: req.type === 'agent' ? '#dbeafe' : '#fed7aa',
                borderColor: req.type === 'agent' ? '#93c5fd' : '#fdba74',
              }}
            >
              {req.emoji}
            </div>

            {/* Info */}
            <div className="flex-1 min-w-0">
              <div className="font-bold text-xs truncate" style={{ color: 'var(--text-link)' }}>{req.name}</div>
              {req.operator && (
                <div className="text-2xs" style={{ color: 'var(--text-muted)' }}>Op: {req.operator}</div>
              )}
            </div>

            {/* Actions */}
            <div className="flex flex-col gap-1 shrink-0">
              <button
                onClick={() => handleConfirm(req.id)}
                className="px-2 py-0.5 font-bold cursor-pointer"
                style={{
                  fontSize: '9px',
                  background: 'var(--accent)',
                  color: 'white',
                  border: '1px solid var(--accent-hover)',
                }}
              >
                Confirm
              </button>
              <button
                onClick={() => handleIgnore(req.id)}
                className="px-2 py-0.5 font-bold cursor-pointer"
                style={{
                  fontSize: '9px',
                  background: 'var(--bg-filter)',
                  color: 'var(--text-muted)',
                  border: '1px solid var(--border-separator)',
                }}
              >
                Ignore
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
